import { ProjectResponse } from './response/project-response';

export interface EstimateNavEntry {
  id: number;
  patentPhase: string;
  estimateId: string;
  projectCategory: string;
  projectEstimateStatus: string;
}

export function estimateToNavEntry(data: ProjectResponse): EstimateNavEntry {
  return {
    id: data.id,
    estimateId: data.estimateId,
    projectCategory: data.projectCategory.projectCategory,
    patentPhase: data.patentPhase,
    projectEstimateStatus: data.projectEstimateStatus,
  };
}
